import { useState, useEffect, useMemo } from "react";
import { useParams,useLocation,Link } from "react-router-dom";

import Heading from "../component/ui/Heading.js";
import Loader from "../component/ui/Loader.js";
import ThumbnailCard from "../component/ThumbnailCard/ThumbnailCard.js";
import MediaMainBG from "../component/MediaMainBG/MediaMainBG.js";
import PreviewImage from "../component/previews/PreviewImage.js";

import { useGetAllCategoriesQuery, useGetVideosByCategoryQuery } from "../services/modulesuser/category";
import Button from "../component/ui/Button.js";
import { skipToken } from "@reduxjs/toolkit/query";

export default function Category() {
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);

  // Carica le categorie
  const {
    data: categoriesRaw = {},
    isLoading: isLoadingCategories,
    error: errorCategories,
  } = useGetAllCategoriesQuery();

  // Estrai array categorie
  const categories = Array.isArray(categoriesRaw?.data?.result)
    ? categoriesRaw.data.result
    : [];
  const visibleCategories = useMemo(
    () =>
      categories.filter(
        (cat) => typeof cat?.name !== "string" || !cat.name.startsWith("_")
      ),
    [categories]
  );

  // Se è la prima volta e ci sono categorie, seleziona la prima
  useEffect(() => {
    if (visibleCategories.length === 0) {
      if (selectedCategoryId !== null) {
        setSelectedCategoryId(null);
      }
      return;
    }

    const selectionMissing = !visibleCategories.some(
      (cat) => cat.id === selectedCategoryId
    );

    if (selectedCategoryId === null || selectionMissing) {
      setSelectedCategoryId(visibleCategories[0].id);
    }
  }, [visibleCategories, selectedCategoryId]);

  // Carica i video della categoria selezionata
  const {
    data: videos = [],
    isLoading: isLoadingVideos,
    error: errorVideos,
  } = useGetVideosByCategoryQuery(
    selectedCategoryId !== null
      ? { categoryId: selectedCategoryId }
      : skipToken
  );

console.log ("Category",videos)
  if (isLoadingCategories || isLoadingVideos) {
    return (
      <div className="flex justify-center items-center h-64">
        <Loader />
      </div>
    );
  }
  if (errorCategories) {
    return (
      <div className="text-center text-red-500 py-4">
        {String(errorCategories)}
      </div>
    );
  }
  if (visibleCategories.length === 0) {
    return (
      <div className="text-center text-gray-500 py-8">
        Nessuna categoria disponibile.
      </div>
    );
  }

  // Render
  return (
    <div className="flex h-full">
   
      <aside className="w-75 p-6 text-white">
        <h2 className="mb-4 text-4xl font-bold uppercase">Categorie</h2>
        <ul className="space-y-2">
          {visibleCategories.map((cat) => (
            <li key={cat.id}>
              <button
                onClick={() => setSelectedCategoryId(cat.id)}
                className={`block w-full text-left px-3 py-2 rounded transition-colors ${selectedCategoryId === cat.id
                    ? "bg-red-600 text-white font-semibold"
                    : "text-gray-300 hover:bg-gray-800"
                  }`}
              >
                {cat.name}
              </button>
            </li>
          ))}
        </ul>
      </aside>

      <div className="space-y-8 flex-1 p-8">
        {/* Titolo categoria */}
      
        <MediaMainBG type="CATEGORIA" />
          <Heading>
          {visibleCategories.find((c) => c.id === selectedCategoryId)?.name || "Categorie"}
        </Heading>

        {/* Sezione video */}
        {isLoadingVideos ? (
          <div className="flex justify-center items-center h-64">
            <Loader />
          </div>
        ) : errorVideos ? (
          <div className="text-center text-red-500 py-4">
            Errore caricamento video
          </div>
        ) : videos.length === 0 ? (
          <p className="text-gray-400 text-center">Nessun video trovato</p>
        ) : (
<div className="flex flex-wrap gap-6 justify-start content-start">
          {videos?.map((video) => (
            <div
              key={video.id}
              style={{ flexBasis: 300 }}
              className="block flex-shrink-0 rounded-lg overflow-x-hidden max-w-[350px] w-full"
            >
              <Link
                to={`/videos/${video.id}`}
                state={{ video: video }}
                className="block"
                style={{ height: 200 }}
              >
                <PreviewImage media={video} type={'tv'} hud={true} />
              </Link>
            </div>
          ))}
          </div>
        )}
      </div>
    </div>
  );
}
